<template>
  <sui-modal class="wrapper" size="small" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Update provider
    </sui-modal-header>
    <sui-modal-content>
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit('update')" v-if="entity">
        <FormProvider v-model="entity" :mode="mode" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button-group>
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit('update')" data-goal="UPDATE_PROVIDER_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </sui-button-group>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import ModalForm from '@/mixins/ModalForm'
  import FormProvider from '@/components/forms/Provider'
  import utils from '@/utils'

  export default {
    name: 'ModalUpdateProvider',
    mixins: [
      ModalForm,
    ],
    components: {
      FormProvider,
    },
    computed: {
      mode() {
        return 'updating'
      },
    },
    methods: {
      open(entity) {
        this.visible = true
        this.entity = cloneDeep(entity)
      },
      onSuccess() {
        this.close()
        utils.reachGoal('UPDATE_PROVIDER_SUCCESS')
      },
      onFail() {
        utils.reachGoal('UPDATE_PROVIDER_FAIL')
      },
    },
    created() {
      this.$modals.updateProvider = this
    },
  }
</script>
